import { blockDataSignalAs } from '@core/block';
import type { CanvasData } from '../definition';

export const blockDataSignal = blockDataSignalAs<CanvasData>('canvas');
